import { ProgressBar } from '@petsmart-ui/sparky';

import { PromoJobAction, PromoJobStatus } from '@/constants';
import { type PromoJob } from '@/types';
import { formatMSTDateCustom } from '@/utils';

import { createTableConfig } from '../../BaseTable/BaseTable';

export const tableConfig = createTableConfig<PromoJob>([
    {
        key: 'action',
        header: 'Action',
        /* @ts-expect-error - The 'remove-all' is temporarily disabled */
        render: job => PromoJobAction[job.action] ?? 'N/A',
    },
    {
        key: 'promoName',
        header: 'Promo Offer',
        render: job => job.promoName ?? 'N/A',
    },
    {
        key: 'createdAt',
        header: 'Started At',
        render: job => formatMSTDateCustom(job.createdAt),
    },
    {
        key: 'progress',
        header: 'Progress',
        render: job => <ProgressBar total={job.totalSkus} value={job.processedSkuCount} />,
    },
    {
        key: 'status',
        header: 'Status',
        render: job => PromoJobStatus[job.status] ?? 'Unknown',
    },
]);
